const ShowCurrentReleaseNotesActionId = 'update.showCurrentReleaseNotes';
const ShowCurrentReleaseNotesFromCurrentFileActionId = 'developer.showCurrentFileAsReleaseNotes';
export { ShowCurrentReleaseNotesActionId, ShowCurrentReleaseNotesFromCurrentFileActionId };
